import React, { useEffect, useState } from "react";
import Clienthomemenu from "../Menus/Clienthomemenu";
import { useNavigate } from "react-router-dom";

export default function Clienthome() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
const [visits, setVisits] = useState(0);
  useEffect(() => {
    const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_GET_VISITOR_COUNT}`;

    fetch(path, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}), // 👈 empty body safe
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.res === "Success") {
          setVisits(data.data.visitor_num);
        }
      })
      .catch((err) => {
        console.log("Visitor counter error", err);
      });
  }, []);
  return (
    <>
      <Clienthomemenu title="EasyITI" />

      <div className="container mt-5 pt-4" style={{height:"750px"}}>
        {/* WELCOME CARD */}
        <div className="card shadow-lg mb-4 border-0">
          <div className="card-body text-center bg-primary text-white rounded">
            <h4 className="mb-1">
              👋 Welcome, {user?.FULL_NAME || "Student"}
            </h4>
            <p className="mb-0">
              Prepare smart. Test yourself. Crack ITI exams 🚀
            </p>
          </div>
        </div>
<div className="small text-muted">
                  👀 Visits: <b>{visits}</b>
                </div>
        {/* ACTION CARDS */}
        <div className="row g-4">
          {/* READ QUESTIONS */}
          <div className="col-md-4">
            <div className="card h-100 shadow border-0">
              <div className="card-body text-center">
                <div className="display-6">📘</div>
                <h5 className="mt-2">Read Questions</h5>
                <p className="text-muted">
                  Topic-wise ITI questions with correct answers
                </p>
                <button
                  className="btn btn-outline-primary"
                  onClick={() => navigate("/reading")}
                >
                  Start Reading
                </button>
              </div>
            </div>
          </div>

          {/* SELF TEST */}
          <div className="col-md-4">
            <div className="card h-100 shadow border-0">
              <div className="card-body text-center">
                <div className="display-6">📝</div>
                <h5 className="mt-2">Self Test</h5>
                <p className="text-muted">
                  Practice with instant result & explanation
                </p>
                <button
                  className="btn btn-outline-success"
                  onClick={() => navigate("/selftest")}
                >
                  Start Test
                </button>
              </div>
            </div>
          </div>

          {/* JOIN TEST */}
          <div className="col-md-4">
            <div className="card h-100 shadow border-0">
              <div className="card-body text-center">
                <div className="display-6">🎯</div>
                <h5 className="mt-2">Join Test</h5>
                <p className="text-muted">
                  Join live tests assigned by instructor
                </p>
                <button
                  className="btn btn-outline-danger"
                  onClick={() => navigate("/jointest")}
                >
                  Join Now
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* HISTORY + MOTIVATION */}
        <div className="row mt-4">
          <div className="col-md-6">
            <div className="card shadow border-0">
              <div className="card-body">
                <h6>📊 Test History</h6>
                <p className="text-muted mb-2">
                  View your past tests, scores and answers
                </p>
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => navigate("/clienttesthistory")}
                >
                  View History
                </button>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="card shadow border-0 bg-light">
              <div className="card-body">
                <h6>💡 Tip of the Day</h6>
                <p className="mb-0">
                  Regular practice increases speed & accuracy.
                  Attempt at least one test daily!
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  );
}
